<template>
  <div>
    <b-tooltip :active=showTooltip :label=formattedPrice :position=tooltipPos :animated=true>
      <div>
        <span>{{formattedDepartTime}}</span>
        <span><b-icon size="is-small" :icon=iconsMap[segment.type]></b-icon></span>
        <span>{{formattedArriveTime}}</span>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
  import format from 'date-fns/format'
  export default {
    name: 'SegmentRow',
    props: ['segment', 'tooltipPos', 'showTooltip'],
    data() {
      return {
        departTime: new Date(this.segment.depart_time),
        arriveTime: new Date(this.segment.arrive_time),
        iconsMap: {
          'ride-share': 'uber',
          'drive': 'car',
          'bus': 'bus',
          'flight': 'airplane'
        }
      };
    },
    computed: {
      formattedDepartTime: function () {
        return format(this.departTime, 'ddd hh:mma');
      },
      formattedArriveTime: function () {
        return format(this.arriveTime, 'ddd hh:mma');
      },
      formattedPrice: function () {
        return "$" + parseFloat(this.segment.price).toFixed(2);
      }
    }

  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SegmentRow.vue